import { Dialog, DialogContent, DialogActions, Typography } from "@mui/material";
import { Button } from "react-admin";

interface FieldMappingEmptyStateProps {
  open: boolean;
  onClose: () => void;
  message: string;
}

/**
 * Empty state component for FieldMappingDialog
 * Shown when there's no template or schema analysis available
 */
export const FieldMappingEmptyState = ({ open, onClose, message }: FieldMappingEmptyStateProps) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent>
        <Typography color="text.secondary">{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};
